import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CORE_ICONS } from './core-icons';

@Injectable({providedIn: 'root'})
export class IconsService
{
    /**
     * Constructor
     */
    constructor()
    {
        const domSanitizer = inject(DomSanitizer);
        const matIconRegistry = inject(MatIconRegistry);

        // Iconos del PRIMER RENDER (layout + dashboard) de los namespaces
        // mat_outline / mat_solid / feather, registrados como iconos
        // individuales inline: tienen precedencia sobre los sets, así el primer
        // paint no descarga ~1,5 MB de sprites por ~16 glifos. Cualquier otro
        // icono de esos namespaces sigue resolviendo contra el set completo
        // (registrado abajo), que se descarga on-demand al pedirse.
        for (const [namespace, icons] of Object.entries(CORE_ICONS)) {
            for (const [name, svg] of Object.entries(icons)) {
                matIconRegistry.addSvgIconLiteralInNamespace(
                    namespace,
                    name,
                    domSanitizer.bypassSecurityTrustHtml(svg),
                );
            }
        }

        // Register icon sets
        matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'));
        matIconRegistry.addSvgIconSetInNamespace('mat_outline', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'));
        matIconRegistry.addSvgIconSetInNamespace('mat_solid', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'));
        matIconRegistry.addSvgIconSetInNamespace('feather', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'));
        matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline.svg'));
        matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'));
        matIconRegistry.addSvgIconSetInNamespace('heroicons_mini', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-mini.svg'));

        // Íconos custom del design system Betterplan (namespace 'bp').
        // sidebar-toggle: panel-left outline para colapsar/expandir el sidebar
        // (provisto por diseño). Usa stroke="currentColor" → hereda el color del mat-icon.
        matIconRegistry.addSvgIconLiteralInNamespace(
            'bp',
            'sidebar-toggle',
            domSanitizer.bypassSecurityTrustHtml(
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="4.5" width="17" height="15" rx="2.5"></rect><path d="M9.5 4.5v15"></path></svg>`,
            ),
        );
    }
}
